// utils/customTheme.ts

import { ThemeConfig, theme } from "antd";

import { APP_FONT_FAMILY } from "@/utils/themes/fontFamily";

export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    fontFamily: APP_FONT_FAMILY,
    colorBgContainer: "#ffffff",
    colorText: "#1D2026",
    colorBorder: "#d1d5db",
    borderRadius: 6,
    controlHeight: 32,
    colorTextPlaceholder: "#9ca3af",
    colorPrimaryHover: "#1e1f4b",
    colorPrimaryActive: "#191a3d",
    colorError: "#ff4d4f",
    colorWarning: "#faad14",
    colorSuccess: "#52c41a",
    colorInfo: "#1890ff",
  },
  components: {
    Input: {
      colorBgContainer: "#ffffff",
      colorText: "#1D2026",
      colorTextPlaceholder: "#9ca3af",
      colorBorder: "#d1d5db",
      borderRadius: 6,
      controlHeight: 32,
      paddingInline: 11,
      paddingBlock: 4,

      hoverBorderColor: "#40a9ff",
      activeShadow: "0 0 0 2px rgba(35, 36, 91, 0.2)",
    },
    InputNumber: {
      colorBgContainer: "#ffffff",
      colorText: "#1D2026",
      colorTextPlaceholder: "#9ca3af",
      colorBorder: "#d1d5db",
      borderRadius: 6,
      controlHeight: 32,

      hoverBorderColor: "#40a9ff",
    },
    Button: {
      colorPrimaryHover: "#145fa8",
      colorPrimaryActive: "#191a3d",
      borderRadius: 6,
      controlHeight: 32,
      paddingInline: 15,
      paddingBlock: 4,
      fontWeight: 500,
      colorText: "#1D2026",
      colorBgContainer: "#ffffff",
      colorBorder: "#d1d5db",
      colorTextDisabled: "#9ca3af",
      colorBgContainerDisabled: "#f3f4f6",
      defaultHoverBorderColor: "#40a9ff",
      defaultHoverColor: "#23245b",
      defaultActiveBorderColor: "#23245b",
      defaultActiveColor: "#191a3d",
    },
    Form: {
      labelColor: "#000000",
      labelFontSize: 14,
      labelHeight: 32,
      labelRequiredMarkColor: "#ff4d4f",
      itemMarginBottom: 24,
      verticalLabelPadding: "0 0 8px",
    },
  },
};

export const lightThemeTokens = {
  sider: {
    colorBgMenuItemSelected: "#Fff",
    textFontWeight: 500,
    textFontSize: 16,
    menuHeight: 40,
    colorTextMenu: "#1D2026",
    colorTextMenuSelected: "#4A6EEC",
    colorBgSider: "#F0F2F4",
  },
  header: {
    colorBgHeader: "#fff",
  },
};
